/**
 * Delete confirmation for Impower inject document lists.
 * Layout/size: custom-document-send-dialog (sm:max-w-md ≈ 448px, p-6).
 * Typography: explicit px (Impower root rem differs from Lux app).
 */
const confirmDeleteImpowerDocument = (documentName, options = {}) => {
  const {
    title = 'Dokument löschen?',
    confirmLabel = 'Löschen',
    cancelLabel = 'Abbrechen',
  } = options

  const displayName =
    (documentName ?? '').length > 80 ? `${String(documentName).substring(0, 80)}…` : (documentName ?? '')
  const message = `Möchten Sie „${escapeHtml(displayName)}“ wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`

  return new Promise((resolve) => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const overlay = document.createElement('div')
    overlay.style.cssText =
      'position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.8);'

    const box = document.createElement('div')
    box.style.cssText = [
      'box-sizing:border-box',
      'width:auto',
      'max-width:448px',
      'margin:0 16px',
      'padding:24px',
      'border:1px solid #e5e7eb',
      'border-radius:8px',
      'background:#fff',
      'box-shadow:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -4px rgba(0,0,0,0.1)',
      'font-family:inherit',
    ].join(';')

    const header = document.createElement('div')
    header.style.cssText = 'display:flex;flex-direction:column;gap:6px;text-align:left;margin-bottom:16px;'

    const titleEl = document.createElement('h2')
    titleEl.textContent = title
    titleEl.style.cssText =
      'margin:0;font-size:18px;line-height:28px;font-weight:600;letter-spacing:-0.025em;color:#0a0a0a;'

    const descriptionEl = document.createElement('p')
    descriptionEl.innerHTML = message
    descriptionEl.style.cssText =
      'margin:0;padding-top:6px;font-size:16px;line-height:24px;color:#71717a;'

    header.appendChild(titleEl)
    header.appendChild(descriptionEl)

    const footer = document.createElement('div')
    footer.style.cssText = 'display:flex;flex-direction:row;justify-content:flex-end;gap:8px;'

    const cancelBtn = document.createElement('button')
    cancelBtn.type = 'button'
    cancelBtn.className = 'ant-btn ant-btn-default'
    cancelBtn.textContent = cancelLabel

    const confirmBtn = document.createElement('button')
    confirmBtn.type = 'button'
    confirmBtn.className = 'ant-btn ant-btn-primary'
    confirmBtn.textContent = confirmLabel
    confirmBtn.style.cssText = 'background:#000;border-color:#000;'

    footer.appendChild(cancelBtn)
    footer.appendChild(confirmBtn)

    box.appendChild(header)
    box.appendChild(footer)
    overlay.appendChild(box)
    document.body.appendChild(overlay)

    const close = (confirmed) => {
      document.body.style.overflow = previousOverflow
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
      resolve(confirmed)
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close(false)
    })
    cancelBtn.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      close(false)
    })
    confirmBtn.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      close(true)
    })
  })
}
